import { render, staticRenderFns } from "./observation.vue?vue&type=template&id=41535f07&scoped=true"
import script from "./observation.vue?vue&type=script&lang=js"
export * from "./observation.vue?vue&type=script&lang=js"
import style0 from "./observation.vue?vue&type=style&index=0&id=41535f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41535f07",
  null
  
)

export default component.exports